// login-frontend/src/components/PetSim/ai/petAi.js
import QTable from "./qlearn";

export const ACTIONS = ["idle", "wander", "seekFood", "nap", "play", "followPlayer"];

const clamp01 = (x) => Math.max(0, Math.min(1, x));
const bin01 = (x, bins = 5) => {
    const v = Math.floor(clamp01(x) * bins);
    return Math.max(0, Math.min(bins, v));
};

export function encodeState(pet, world) {
    const h = bin01(pet.hunger);
    const e = bin01(pet.energy);
    const b = bin01(pet.boredom);

    const dFood = Math.min(4, Math.floor((world.distToFood ?? 9999) / 100));   // NEW: food distance
    const dPlayer = Math.min(4, Math.floor((world.distToPlayer ?? 0) / 100));
    const day = world.isDay ? 1 : 0;

    // include food distance so the brain can learn "go eat when hungry & food is near"
    return `h${h}|e${e}|b${b}|f${dFood}|p${dPlayer}|d${day}`;
}

export function reward(prev, curr, action) {
    // lower hunger/boredom + higher energy → reward
    const dh = prev.hunger - curr.hunger;
    const db = prev.boredom - curr.boredom;
    const de = curr.energy - prev.energy;
    let r = 0.005 + 0.5 * dh + 0.4 * db + 0.3 * de;

    if (action === "idle") r -= 0.01;
    if (curr.hunger > 0.8) r -= 0.02;
    if (curr.energy < 0.2 && action !== "nap") r -= 0.01;
    if (curr.boredom > 0.8 && action !== "play") r -= 0.01;

    return r;
}

export function doAction(scene, pet, action) {
    switch (action) {
        case "idle": return scene.petIdle(pet);
        case "wander": return scene.petWander(pet);
        case "seekFood": return scene.petSeekFood(pet);      // now goes to nearest dropped food
        case "nap": return scene.petNap(pet);
        case "play": return scene.petPlay(pet);
        case "followPlayer": return scene.petFollowPlayer(pet);
        default: return 350;
    }
}

export class PetBrain {
    constructor({ alpha, gamma, epsilon } = {}) {
        this.q = new QTable({ actions: ACTIONS, alpha, gamma, epsilon });
        this.training = true;
    }
    act(key) { return this.q.act(key); }
    step(prevSnap, currSnap, aIdx, sPrev, sCurr) {
        if (!this.training) return;
        const r = reward(prevSnap, currSnap, ACTIONS[aIdx]);
        this.q.update(sPrev, aIdx, r, sCurr);
    }
    save(name = "petsim.brain") {
        localStorage.setItem(name, JSON.stringify(this.q.toJSON()));
    }
    load(name = "petsim.brain") {
        const raw = localStorage.getItem(name);
        if (!raw) return false;
        this.q = QTable.fromJSON(JSON.parse(raw));
        return true;
    }
    reset() {
        const { actions, alpha, gamma, epsilon } = this.q;
        this.q = new QTable({ actions, alpha, gamma, epsilon });
    }
}
